const buildPosition = ({ x, y, width, height, sortId, type }) => {
  return {
    position: 'absolute',
    whiteSpace: 'pre',
    zIndex: sortId,
    left: x - 8 * x / 100,
    top: y - 8 * y / 100,
    height: type === 'image' || type === 'rectangle' ? `${height - (8 * height / 100)}px` : undefined,
    width: type === 'image' || type === 'rectangle' ? `${width - (8 * width / 100)}px` : undefined,
    maxWidth: 'unset',
  }
}

export default buildPosition
